import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Drug, Search } from '../models';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class PharmacyService {
  constructor(
    private http: HttpClient,
  ) {}

  /**
   * Gets the drugs
   * @return server response
   */
  getDrugs() {
    return this.http.get( 'drugs').pipe(map(response => response as Drug[]));
  }

  /**
   * Filters the drugs
   * @param searchCriteria
   * @return server response
   */
  getFilteredDrugs(formData: FormData) {
    return this.http.post( 'filter-drugs', formData).pipe(map(response => response as Drug[]));
  }

  /**
   * Post a drug
   *
   * @param formData
   */
  postDrug(formData: any) {
    return this.http.post( 'drug', formData).pipe(map(response => response as Drug));
  }

  /**
   * Updates the drug in the db
   *
   * @param drugData to edit
   * @param id to drug's id
   * @returns Observable<any>
   */
  editDrug(id: number, drugData: any) {
    return this.http.post(`drug/${id}`, drugData);
  }

  /**
   * Deleted the drug from the db
   *
   * @param id to edit
   * @returns Observable<any>
   */
  deleteDrug(id: number) {
    return this.http.delete(`drug/${id}`);
  }

  /**
   * sends ids in the cart 
   * @param formData cart drug ids
   * @returns recommended drugs
   */
  getRecommendedDrugs(formData: FormData) {
    return this.http.post( 'recommended-drugs', formData).pipe(map(response => response));
  }

  /**
   * upload prescription image
   *
   * @param data
   */
  uploadPrescription(formData: FormData) {
    return this.http.post( 'send-prescription', formData).pipe(map(response => response));
  } 

}
